import React from 'react';
import PropTypes from 'prop-types';
import ErrorMessage from './ErrorMessage';
import _ from 'lodash';

RequestError.propTypes = {
  request: PropTypes.object,
  v2: PropTypes.bool
};

export default function RequestError(props) {
  const {request, v2 = false} = props;
  if (!request) return null;
  const error = request.error || {};
  /** @type {string} */
  let text;

  if (error.message) {
    text = error.message;
  } else if (_.isPlainObject(error)) {
    text = JSON.stringify(error);
  } else if (_.isArray(error)) {
    text = JSON.stringify(error);
  } else {
    text = String(error);
  }

  return (
    <ErrorMessage v2={v2}>
      <strong>Error!</strong> {text}
    </ErrorMessage>
  );
}
